export const City_Names_Per_RT={
  "01: Cosmopolitan Urban Area": [
    "Delhi NCR",
    "Bangalore",
    "KMA",
    "Chennai",
    "Hyderabad",
    "MMR",
    "Ahmadabad-Gandhinagar",
    "Lucknow",
    "Pune-PCMC",
    "Surat",
    "Jaipur"
  ],
  "02: Sub-Metropolitan Urban Area": [
    "Bhopal",
    "Indore",
    "Ludhiana",
    "Vadodara",
    "Nagpur",
    "Prayagraj",
    "Agra",
    "Kanpur",
    "Bhubaneswar-Cuttack Twin City",
    "Patna",
    "Rajkot",
    "Thiruvananthapuram",
    "Raipur",
    "Jodhpur",
    "Varanasi",
    "Vishakhapatnam",
    "Ranchi",
    "Kota",
    "Dhanbad",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Meerut",
    "Jalandhar",
    "Kochi",
    "Vijayawada",
    "Coimbatore",
    "Aurangabad",
    "Solapur",
    "Moradabad",
    "Jabalpur",
    "Chandigarh Tricity",
    "Mysore",
    "Nashik",
    "Guwahati",
    "Bareilly",
    "Aligarh",
    "Amritsar",
    "Kozhikode",
    "Gwalior",
    "Warangal",
    "Saharanpur",
    "Hubli-Dharwad"
  ]
}